import { render, staticRenderFns } from "./PayFees.vue?vue&type=template&id=f8c770f4&scoped=true"
import script from "./PayFees.vue?vue&type=script&lang=js"
export * from "./PayFees.vue?vue&type=script&lang=js"
import style0 from "./PayFees.vue?vue&type=style&index=0&id=f8c770f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c770f4",
  null
  
)

export default component.exports